/**
 * @class Oskari.catalogue.bundle.metadataflyout.Tile
 */
Oskari.clazz.define('Oskari.catalogue.bundle.metadataflyout.Tile',
/**
 * @method create called automatically on construction
 * @static
 */
function (instance, locale) {
  this.instance = instance;
  this.locale = locale;
  this.container = null;
  this.template = null;
}, {
  getName: function getName() {
    return 'Oskari.catalogue.bundle.metadataflyout.Tile';
  },
  setEl: function setEl(el, width, height) {
    this.container = jQuery(el);
  },
  startPlugin: function startPlugin() {
    this.refresh();
  },
  stopPlugin: function stopPlugin() {
    this.container.empty();
  },
  getTitle: function getTitle() {
    return this.locale.title;
  },
  getDescription: function getDescription() {},
  getOptions: function getOptions() {},
  setState: function setState(state) {
    this.state = state;
  },
  refresh: function refresh() {}
}, {
  'protocol': ['Oskari.userinterface.Tile']
});